import { render } from "./PublicationCollaboratorCardSmall.vue.js?vue&type=template&id=4dcb71af&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaboratorCardSmall.vue?vue&type=template&id=4dcb71af&scoped=true"
import script from "./PublicationCollaboratorCardSmall.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaboratorCardSmall.vue?vue&type=script&lang=js"
export * from "./PublicationCollaboratorCardSmall.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaboratorCardSmall.vue?vue&type=script&lang=js"

import "./PublicationCollaboratorCardSmall.vue.scss?vue&type=style&index=0&id=4dcb71af&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaboratorCardSmall.vue?vue&type=style&index=0&id=4dcb71af&scoped=true&lang=scss"
import "./PublicationCollaboratorCardSmall.vue.css?vue&type=style&index=1&id=4dcb71af&lang=css!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaboratorCardSmall.vue?vue&type=style&index=1&id=4dcb71af&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcb71af"],['__file',"src/SmartFeed/scripts/components/publication/layouts/PublicationCollaboratorCardSmall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dcb71af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dcb71af', __exports__)) {
    api.reload('4dcb71af', __exports__)
  }
  
  module.hot.accept("./PublicationCollaboratorCardSmall.vue.js?vue&type=template&id=4dcb71af&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationCollaboratorCardSmall.vue?vue&type=template&id=4dcb71af&scoped=true", () => {
    api.rerender('4dcb71af', render)
  })

}


export default __exports__